import * as yup from "yup";

export type SetCalculationFormValues = {
    emissionsFactor: number;
    activeFrom: Date | null;
    confidenceId: number;
    confidenceReason: string;
    normalizedUnitsId: number;
    conversionFactor: number;
};

export const defaultEmissionsFactorInputErrorMessage =
    "Please enter a valid emissions factor";

export const emissionsFactorFormValidationSchema = yup.object({
    emissionsFactor: yup
        .number()
        .typeError(defaultEmissionsFactorInputErrorMessage)
        .required(defaultEmissionsFactorInputErrorMessage)
        .min(0, "Emissions factor must be greater than or equal to 0."),
    activeFrom: yup
        .date()
        .required("Please enter applicable from date")
        .typeError("Please enter a valid date"),
    normalizedUnitsId: yup
        .number()
        .moreThan(0, "Please select normalized units"),
    conversionFactor: yup
        .number()
        .moreThan(0, "Conversion factor must be greater than 0")
        .required("Please enter conversion factor"),
});

export const defaultSetCalculationFormValues: Partial<SetCalculationFormValues> =
    {
        activeFrom: null,
        normalizedUnitsId: -1,
        conversionFactor: 0,
        confidenceReason: "default",
        confidenceId: 1
    };
